import React from "react";
import qrcode from '../../assets/images/qrcode.png';
import numberbeautify from "../../utils/numberbeautify";
import './loanbackprint.css';
import Logo from '../../assets/images/logo.png'
import money_rounding from "../../utils/money_rounding";
import iqd_rounding from "../../utils/iqd_rounding";
import moment from "moment/moment";

export const Loanbackprint = React.forwardRef((props, ref) => {
  return (
     <div ref={ref}>
        <div dir="rtl" className="h-[47vh] border-b-2 border-dotted border-black">
          <div className="py-2 bottom-1">
            <div className="px-14 py-7 relative flex justify-between items-center">
              <div>
                <p className="whitespace-nowrap text-slate-400 text-right">بەروار</p>
                <p className="whitespace-nowrap font-medium text-right text-[#D9A919]">{moment(props?.loan_in_date).format("YYYY-MM-DD hh:mm A")}</p>
              </div>
              <div>
                <img src={Logo} className="h-24 absolute left-1/2 transform -translate-x-1/4 -top-1" />
              </div>
              <div className="flex">
                <div className="mx-3">
                    <p className="whitespace-nowrap text-slate-400 text-right">ژمارەی پسوڵە #</p>
                    <p className="whitespace-nowrap font-medium text-right text-[#D9A919]">{props?.loan_in_id}</p>
                </div>
                <div className="mx-3">
                    <p className="whitespace-nowrap text-slate-400 text-right">نرخی دۆلار</p>
                    <p className="whitespace-nowrap font-medium text-right text-[#D9A919]">{numberbeautify(props?.dollar_price)}</p>
                </div>
              </div>
            </div>
            <div className="bg-slate-100 px-14 py-4 text-sm">
              <table className="w-full border-collapse border-spacing-0">
                <tbody>
                  <tr>
                    <td className="w-1/2 align-top">
                      <div className="text-sm text-neutral-600">
                        <div className="flex">
                          <p className="font-medium text-lg">بەڕێز: </p>
                          <p className="font-medium text-lg mx-1">{props?.customer_name}</p>
                        </div>
                        <div className="flex">
                          <p className="text-lg">ناونیشان: </p>
                          <p className="text-lg mx-1">{props?.customer_address}</p>
                        </div>
                        <div className="flex">
                          <p className="text-lg">ژمارەی تەلەفۆن: </p>
                          <p className="text-lg mx-1">{props?.customer_phone}</p>
                        </div>
                        <p></p>
                        <p></p>
                        <p></p>
                        <p></p>
                      </div>
                    </td>
                    <td className="w-1/2 align-top text-right">
                      <div className="text-sm text-neutral-600">
                        <p className="font-medium text-2xl text-[#D9A919]">کۆمپانیای خەندەی ماڵ</p>
                        <p className="text-lg">بۆ بازرگانی گشتی سنوردار / پێداویستی ناوماڵ</p>
                        <p className="text-lg">سلێمانی - ژاڵەی سەروو - کۆگاکانی ژووری بازرگانی</p>
                        <p className="text-lg">ژمارەی گەنجینە: ۲۷٥</p>
                        <p className="text-lg" dir="ltr">0770 159 1344 - 0770 152 8160</p>
                        <p></p>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
        </div>      
        <div className="text-center text-2xl">
          پسوڵەی گەڕاندنەوەی قەرز
        </div>
        <div className="px-14 py-3 text-sm text-neutral-700">
              <table className="w-full border-collapse border-spacing-0">
                <tbody>
                  <tr className="border-2 border-black">
                    <th>بڕی قەرزی گەڕاوە</th>
                    <th>{numberbeautify(money_rounding(props?.amount))} $</th>
                  </tr>
                  <tr className="border-2 border-black">
                    <th>بڕی قەرزی گەڕاوە - دینار</th>
                    <th>{numberbeautify(money_rounding(Number(props?.amount)*Number(props?.dollar_price)))}</th>
                  </tr>
                  <tr className="border-2 border-black">
                    <th>بڕی قەرزی ماوە</th>
                    {
                      props?.sub_state=="ok"?
                      <th>{numberbeautify(money_rounding(Number(props?.customer_loan)))} $</th>:
                      <th>{numberbeautify(money_rounding(Number(props?.customer_loan)-Number(props?.amount)))} $</th>
                    }
                  </tr>
                  <tr className="border-2 border-black">
                    <th>تێبینی</th>
                    <th>{props?.note}</th>
                  </tr>
                </tbody>
              </table>
        </div>
        <div className="px-14 mt-1 mb-5 text-sm text-neutral-700">
          ئیمزای وەرگر:
        </div>
      </div>
      <div dir="rtl" className="h-[47vh]">
          <div className="py-2">
            <div className="px-14 py-7 relative flex justify-between items-center">
              <div>
                <p className="whitespace-nowrap text-slate-400 text-right">بەروار</p>
                <p className="whitespace-nowrap font-medium text-right text-[#D9A919]">{moment(props?.loan_in_date).format("YYYY-MM-DD hh:mm A")}</p>
              </div>
              <div>
                <img src={Logo} className="h-24 absolute left-1/2 transform -translate-x-1/4 -top-1" />
              </div>
              <div className="flex">
                <div className="mx-3">
                    <p className="whitespace-nowrap text-slate-400 text-right">ژمارەی پسوڵە #</p>
                    <p className="whitespace-nowrap font-medium text-right text-[#D9A919]">{props?.loan_in_id}</p>
                </div>
                <div className="mx-3">
                    <p className="whitespace-nowrap text-slate-400 text-right">نرخی دۆلار</p>
                    <p className="whitespace-nowrap font-medium text-right text-[#D9A919]">{numberbeautify(props?.dollar_price)}</p>
                </div>
              </div>
            </div>
            <div className="bg-slate-100 px-14 py-4 text-sm">
              <table className="w-full border-collapse border-spacing-0">
                <tbody>
                  <tr>
                    <td className="w-1/2 align-top">
                      <div className="text-sm text-neutral-600">
                        <div className="flex">
                          <p className="font-medium text-lg">بەڕێز: </p>
                          <p className="font-medium text-lg mx-1">{props?.customer_name}</p>
                        </div>
                        <div className="flex">
                          <p className="text-lg">ناونیشان: </p>
                          <p className="text-lg mx-1">{props?.customer_address}</p>
                        </div>
                        <div className="flex">
                          <p className="text-lg">ژمارەی تەلەفۆن: </p>
                          <p className="text-lg mx-1">{props?.customer_phone}</p>
                        </div>
                        <p></p>
                        <p></p>
                        <p></p>
                        <p></p>
                      </div>
                    </td>
                    <td className="w-1/2 align-top text-right">
                      <div className="text-sm text-neutral-600">
                        <p className="font-medium text-2xl text-[#D9A919]">کۆمپانیای خەندەی ماڵ</p>
                        <p className="text-lg">بۆ بازرگانی گشتی سنوردار / پێداویستی ناوماڵ</p>
                        <p className="text-lg">سلێمانی - ژاڵەی سەروو - کۆگاکانی ژووری بازرگانی</p>
                        <p className="text-lg">ژمارەی گەنجینە: ۲۷٥</p>
                        <p className="text-lg" dir="ltr">0770 159 1344 - 0770 152 8160</p>
                        <p></p>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
        </div>      
        <div className="text-center text-2xl">
          پسوڵەی گەڕاندنەوەی قەرز
        </div>
        <div className="px-14 py-3 text-sm text-neutral-700">
              <table className="w-full border-collapse border-spacing-0">
                <tbody>
                  <tr className="border-2 border-black">
                    <th>بڕی قەرزی گەڕاوە</th>
                    <th>{numberbeautify(money_rounding(props?.amount))} $</th>
                  </tr>
                  <tr className="border-2 border-black">
                    <th>بڕی قەرزی گەڕاوە - دینار</th>
                    <th>{numberbeautify(money_rounding(Number(props?.amount)*Number(props?.dollar_price)))}</th>
                  </tr>
                  <tr className="border-2 border-black">
                    <th>بڕی قەرزی ماوە</th>
                    {
                      props?.sub_state=="ok"?
                      <th>{numberbeautify(money_rounding(Number(props?.customer_loan)))} $</th>:
                      <th>{numberbeautify(money_rounding(Number(props?.customer_loan)-Number(props?.amount)))} $</th>
                    }
                  </tr>
                  <tr className="border-2 border-black">
                    <th>تێبینی</th>
                    <th>{props?.note}</th>
                  </tr>
                </tbody>
              </table>
        </div>
        <div className="px-14 mt-1 mb-5 text-sm text-neutral-700">
          ئیمزای وەرگر:
        </div>
      </div>
     </div>
  );
});